import { createContext, useContext, useState, type FC, type PropsWithChildren } from "react";

const HeaderBarToolsContainerContext = createContext<HTMLDivElement | null>(null);
const SetHeaderBarToolsContainerContext = createContext<React.Dispatch<React.SetStateAction<HTMLDivElement | null>> | null>(null);

export const HeaderBarProvider: FC<PropsWithChildren> = ({ children }) => {
	const [container, setContainer] = useState<HTMLDivElement | null>(null);

	return (
		<SetHeaderBarToolsContainerContext.Provider value={setContainer}>
			<HeaderBarToolsContainerContext.Provider value={container}>
				{children}
			</HeaderBarToolsContainerContext.Provider>
		</SetHeaderBarToolsContainerContext.Provider>
	);
};

export const useHeaderBarToolsContainer = (): HTMLDivElement | null => {
	return useContext(HeaderBarToolsContainerContext);
};

export const useSetHeaderBarToolsContainer = (): React.Dispatch<React.SetStateAction<HTMLDivElement | null>> | null => {
	return useContext(SetHeaderBarToolsContainerContext);
};
